import { Component, Input, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject, takeUntil } from 'rxjs';

import { DashpivotEvent, EventNotifierService, EventTypes } from '@site-mate/dashpivot-shared-library';

import { SegmentService } from 'app/segment/segment.service';
import { AccordionPanel } from 'app/shared/model/accordion-panel.model';
import { RouteParamsService } from 'app/shared/service/route-params.service';
import { SignUpCompanyBrandingComponent } from 'app/user/sign-up-simplified/sign-up-steps/sign-up-company-branding/sign-up-company-branding.component';

@Component({
  selector: 'cc-trial-start-guide-accordion',
  templateUrl: './trial-start-guide-accordion.component.html',
  styleUrls: ['./trial-start-guide-accordion.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class TrialStartGuideAccordionComponent implements OnInit, OnDestroy {
  private unSubscribe = new Subject<void>();
  @Input() accordionPanels: AccordionPanel[];

  companyLogo: string;
  colorCode: string;

  constructor(
    private readonly segmentService: SegmentService,
    private readonly modal: NgbModal,
    private readonly routeParamsService: RouteParamsService,
  ) {}

  trackAccordionClick(eventType: EventTypes, context: string): void {
    void EventNotifierService.notify(
      new DashpivotEvent(eventType, { Context: context }),
      this.segmentService,
    );
  }

  ngOnInit(): void {
    this.routeParamsService
      .get('company')
      .pipe(takeUntil(this.unSubscribe))
      .subscribe((company) => {
        this.companyLogo = company?.logo;
        this.colorCode = company?.colorCode;
      });
  }

  ngOnDestroy(): void {
    this.unSubscribe.next();
    this.unSubscribe.complete();
  }

  openCompanyLogoModal(): void {
    const modalRef = this.modal.open(SignUpCompanyBrandingComponent, {
      size: 'lg',
      windowClass: 'modal-400',
      modalDialogClass: 'modal-dialog-centered',
      animation: false,
    });
    modalRef.componentInstance.isTrialGuideUpload = true;
    modalRef.componentInstance.companyLogo = this.companyLogo;
    modalRef.componentInstance.colorCode = this.colorCode;
  }
}
